import React, { Fragment, useRef } from "react";
import { useState, useEffect } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import MainTopFilters from "../App/MainTopFilters";
import { type } from "os";
import { json } from "d3";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import {
  DownloadClientsDataInExcel,
  getAccessSettings,
  removeNonNumeric,
} from "../Shared/Utility";
import DragDrop from "../DragDrop/DragDrop";
import DownloadPopup from "../App/DownloadPopup";
import InputMaskReadOnly from "../App/InputMaskReadOnly";
import ApprovalsScreen from "./ApprovalsScreen";
import SignaturePadControl from "../App/SignaturePadControl";

function BulkInput() {
  const globalState = useGlobalState();

  const [showAnimation, setShowAnimation] = useState(false);
  const [deadlineAccessData, setDeadlineAccessData] = useState({
    CanInputData: 0,
    CanApproveData: 0,
  });

  const [bulkInputFilter, setBulkInputFilter] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    IBBDepartmentID: 0,
    SectionID: 0,
    TypeID: 1,
  });

  const [programList, setProgramList] = useState<any>([]);

  const [quarterList, setQuarterList] = useState<any>([]);

  const [typeList, setTypeList] = useState<any>([
    {
      PID: 1,
      Name: "Targets",
    },
    {
      PID: 2,
      Name: "Actuals",
    },
  ]);

  const [sectionsList, setSectionsList] = useState<any>([]);
  const [inputData, setInputData] = useState<any>([]);
  const [inputDataColumns, setInputDataColumns] = useState<any>([]);
  const [downloadInputData, setDownloadInputData] = useState<any>([]);

  //MM:: Approval related data
  const [requiredApprovalUser, setRequiredApprovalUser] = useState([]) as any;
  const [approvalDataModal, setApprovalDataModal] = useState(false);
  const [approvalDataModalConfirmation, setApprovalDataModalConfirmation] =
    useState(false);
  const [approvalData, setApprovalData] = useState({}) as any;

  const [showDragDropModal, setShowDragDropModal] = useState(false);

  const [selectedApprovalUsers, setSelectedApprovalUsers] = useState([]) as any;
  const [selectedApprovalObjects, setSelectedApprovalObjects] = useState(
    []
  ) as any;

  const [canTakeActionItems, setCanTakeActionItems] = useState(0);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = bulkInputFilter.ProgramID;

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = bulkInputFilter.QuarterID;

    let SectionID = params.get("secid") as any;
    if (SectionID && SectionID != "") SectionID = Number(SectionID);
    else SectionID = bulkInputFilter.SectionID;

    let TypeID = params.get("tid") as any;
    if (TypeID && TypeID != "") TypeID = Number(TypeID);
    else TypeID = bulkInputFilter.TypeID;

    setBulkInputFilter((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      QuarterID: QuarterID,
      SectionID: SectionID,
      TypeID: TypeID,
    }));

    IBBProgramGetProgramListForScorecard(IBBProgramID, QuarterID, 0, 0);
  }, []);

  useEffect(() => {
    if (bulkInputFilter.ProgramID > 0)
      IBBProgramGetSectionAndCriteriaDataForScorecard(
        bulkInputFilter.ProgramID
      );
  }, [bulkInputFilter.ProgramID]);

  useEffect(() => {
    if (bulkInputFilter.SectionID > 0) IBBScorecardGetDataForBulkInput(0);
  }, [
    bulkInputFilter.ProgramID,
    bulkInputFilter.QuarterID,
    bulkInputFilter.SectionID,
    bulkInputFilter.TypeID,
  ]);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number,
    IBBScorecardID: number,
    PFIDealerID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = bulkInputFilter.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = QuarterID;
    object.pfidealerid = PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setBulkInputFilter((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }
          }

          setQuarterList(result[2]);
          if (QuarterID == 0) {
            let QuarterID = result[2][0].PID;
            setBulkInputFilter((prevState: any) => ({
              ...prevState,
              QuarterID: QuarterID,
            }));
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetSectionAndCriteriaDataForScorecard(
    IBBProgramID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = bulkInputFilter.ProgramID;

    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetSectionAndCriteriaDataForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          var filtered = result[0].filter((item: any) => item.Type == 2);
          let sectionsListLocal = [] as any;

          for (let i = 0; i < filtered.length; i++) {
            let section = filtered[i];
            if (getAccessSettings(1, section.IBBDepartmentID) > 0)
              sectionsListLocal.push(section);
          }

          setSectionsList(sectionsListLocal);
          if (sectionsListLocal.length > 0) {
            let SectionID = sectionsListLocal[0].SectionID;
            if (bulkInputFilter.SectionID > 0)
              SectionID = bulkInputFilter.SectionID;
            setBulkInputFilter((prevState: any) => ({
              ...prevState,
              SectionID: SectionID,
              IBBDepartmentID: sectionsListLocal[0].IBBDepartmentID,
            }));
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBScorecardGetDataForBulkInput(IsDownloadLink: number) {
    setSelectedApprovalObjects([]);
    setSelectedApprovalUsers([]);

    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = bulkInputFilter.ProgramID;
    object.numericyear = 0;
    object.numericquarter = bulkInputFilter.QuarterID;
    object.ibbprogramstageid = bulkInputFilter.TypeID == 1 ? 10 : 13; //TODO:: MM check this
    object.sectionid = bulkInputFilter.SectionID;
    object.typeid = bulkInputFilter.TypeID;
    object.isdownloadlink = IsDownloadLink;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecard/IBBScorecardGetDataForBulkInput",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (IsDownloadLink == 0 || IsDownloadLink == 1) {
            if (result[0].length > 0) {
              let columnsList = Object.keys(result[0][0]);
              let columnsDataFormat = [] as any;
              for (let i = 0; i < columnsList.length; i++) {
                var filtered = result[3].filter(
                  (item: any) => item.Title == columnsList[i]
                );
                let dataFormat = {} as any;
                if (filtered.length > 0) dataFormat = filtered[0];
                else {
                  let columnNames = columnsList[i].split(" - ");
                  if (columnNames.length > 1) {
                    filtered = result[3].filter(
                      (item: any) =>
                        item.Actual1Title == columnNames[1] ||
                        item.Actual2Title == columnNames[1]
                    );
                    if (filtered.length > 0) dataFormat = filtered[0];
                  }
                }
                columnsDataFormat.push({
                  ColumnName: columnsList[i],
                  DataFormat: dataFormat,
                });
              }
              setInputDataColumns(columnsDataFormat);

              let canTakeActionItems = 0;
              for (let i = 0; i < result[0].length; i++) {
                let IBBScorecardID = result[0][i].SCID;
                filtered = result[2].filter(
                  (item: any) => item.IBBScorecardID == IBBScorecardID
                );
                if (filtered.length > 0) {
                  result[0][i].ApprovalStatus =
                    bulkInputFilter.TypeID == 1
                      ? filtered[0].TargetApprovalStatus
                      : filtered[0].ActualApprovalStatus;
                }
                filtered = result[5].filter(
                  (item: any) =>
                    item.IBBScorecardID == IBBScorecardID &&
                    item.CanTakeAction == 1
                );
                if (filtered.length > 0) {
                  result[0][i].ApprovalData = filtered[0];
                  canTakeActionItems += 1;
                }
              }
              setCanTakeActionItems(canTakeActionItems);

              let IBBScorecardID = 0;
              for (let i = 0; i < result[5].length; i++) {
                if (result[5][i].IBBScorecardID != IBBScorecardID) {
                  result[5][i].ShowTitle = 1;
                  IBBScorecardID = result[5][i].IBBScorecardID;
                }
              }

              setRequiredApprovalUser(result[5]);
              if (result[7].length > 0) setDeadlineAccessData(result[7][0]);
            } else setInputDataColumns([]);
            setInputData(result[0]);
          }
          if (IsDownloadLink == 1) {
            setDownloadInputData(result[1]);
            if (result[1].length > 0) {
              setPopUpFileURL(result[1][0].DownloadData);
              setPopUpMessage("Data has been exported to file successfully!");
              setShowPopUp(true);
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: bulkInputFilter.SectionID,
    ObjectType: AppContext.FileUploadObjectTypeBulkInput,
    MaxAllowedFiles: 1,
    UploadType: 4,
    FolderName: "IBBBulkInput",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpFileURL, setPopUpFileURL] = useState("");
  const [popUpMessage, setPopUpMessage] = useState(
    "Data has been exported to file successfully!"
  );

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  function DownloadPopupCallBack() {
    setShowPopUp(false);
    setPopUpFileURL("");
  }

  function showPopUpForSaveFiles() {
    if (uploadFileList && uploadFileList.length > 0) SaveFiles();
    else
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "Alert",
        Message: "Please select file to upload.",
      });
  }

  function SaveFiles() {
    if (uploadFileList && uploadFileList.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeatures.ObjectType;
      object.objectid = dragDropFeatures.ObjectID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            IBBScorecardSaveInputDataFromExcelImport(l_response);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
    }
  }

  function IBBScorecardSaveInputDataFromExcelImport(p_S3UploadFileList: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = bulkInputFilter.ProgramID;
    object.numericyear = 0;
    object.numericquarter = bulkInputFilter.QuarterID;
    object.ibbprogramstageid = 10;
    object.sectionid = bulkInputFilter.SectionID;
    object.typeid = bulkInputFilter.TypeID;
    object.filesdata = p_S3UploadFileList;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecard/IBBScorecardSaveInputDataFromExcelImport",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          let link = l_response[0][0].LogFile;

          setShowAnimation(false);

          if (
            l_response.length > 0 &&
            l_response[0].length > 0 &&
            l_response[0][0].Message != ""
          ) {
            setPopUpMessage(l_response[0][0].Message);
            setShowPopUp(true);
          }

          IBBScorecardGetDataForBulkInput(0);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function triggerApprovalParent() {
    IBBScorecardGetDataForBulkInput(0);
  }

  const [dragDropFeaturesModal, setDragDropFeaturesModal] = useState({
    ObjectID: bulkInputFilter.SectionID,
    ObjectType: AppContext.FileUploadObjectTypeScorecardActualsEvidenceFile,
    MaxAllowedFiles: 5,
    UploadType: 1,
    FolderName: "IBBBulkInput",
    PTUploadedFiles: [],
  });

  const [uploadFileListModal, setUploadFileListModal] = useState<any>([]);
  const [triggerChildModal, setTriggerChildModal] = useState(false);

  function handleDragDropCallbackModal(ChildData: any) {
    setUploadFileListModal(ChildData);
  }

  function SaveFilesModal() {
    let uploadFileListArray = [];
    for (let index = 0; index < uploadFileListModal.length; index++) {
      if (!uploadFileListModal[index].AlreadyUploaded) {
        uploadFileListArray.push(uploadFileListModal[index]);
      }
    }

    if (uploadFileListArray && uploadFileListArray.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeaturesModal.ObjectType;
      object.objectid = dragDropFeaturesModal.ObjectID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileListArray;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChildModal(!triggerChild);
            let l_response = response.data.Data;

            let uploadFileArray = [];
            for (let index = 0; index < uploadFileListModal.length; index++) {
              if (uploadFileListModal[index].AlreadyUploaded) {
                uploadFileArray.push(uploadFileListModal[index]);
              }
            }
            for (let index = 0; index < l_response.length; index++) {
              uploadFileArray.push(l_response[index]);
            }

            saveAttachmentDataForObjectTypeIDObjectID(uploadFileArray);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      saveAttachmentDataForObjectTypeIDObjectID(uploadFileListModal);
    }
  }

  function saveAttachmentDataForObjectTypeIDObjectID(uploadedFileList: any) {
    let object = {} as any;
    object.objecttype =
      AppContext.FileUploadObjectTypeScorecardActualsEvidenceFile;
    object.objectid = bulkInputFilter.SectionID;
    object.typeid = approvalData.SCID;
    object.filesdata = uploadedFileList;
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PTAttachment/SaveAttachmentDataForObjectTypeIDObjectID",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          //console.log("log", response.data.Message);
        } else {
          console.error("error", response.data.Message);
        }
        setShowDragDropModal(false);
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getAttachmentDataForObjectTypeAndObjectID(
    objecttype: any,
    objectid: any,
    typeid: any
  ) {
    let object = {} as any;
    object.typeid = typeid;
    object.objecttype = objecttype;
    object.objectid = objectid;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PTAttachment/GetAttachmentDataForObjectTypeAndObjectID",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          dragDropFeaturesModal.PTUploadedFiles = [];
          let gridData = response.data.Data;
          let attachments = [] as any;
          if (gridData && gridData[0] && gridData[0].length > 0) {
            for (let i = 0; i < gridData[0].length; i++) {
              // if (gridData[3][i].ObjectID == id) {
              attachments.push({
                ObjectID: gridData[0][i].ObjectID,
                Name: gridData[0][i].Name,
                FileURLDisplay: AppContext.GetFileIconToDisplay(
                  gridData[0][i].FileURLRaw
                ),
                FileURL: gridData[0][i].FileURLRaw,
                AlreadyUploaded: true,
                S3Path: gridData[0][i].S3Path,
                Identifier: gridData[0][i].Identifier,
                Title: gridData[0][i].Title,
                Tags: gridData[0][i].Tags,
              });
              // }
            }
          }
          dragDropFeaturesModal.PTUploadedFiles = attachments;
          setDragDropFeaturesModal((prevState: any) => ({
            ...prevState,
            PTUploadedFiles: attachments,
          }));
        } else {
          console.error("error", response.data.Message);
        }
        setShowAnimation(false);
        setShowDragDropModal(true);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBApprovalSaveCustomBulkApprovals(uploadedFileList: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbrequiredapprovalusers = selectedApprovalUsers;
    object.ibbdelegatedid = approvalData.IBBDelegateID;
    object.ibbprogramid = bulkInputFilter.ProgramID;
    object.quarterid = bulkInputFilter.QuarterID;
    object.name = bulkInputFilter.SectionID;
    object.status = approvalData.Status;
    object.notes = approvalData.Notes;
    object.objecttype = bulkInputFilter.TypeID == 1 ? 10 : 14;
    object.objectids = selectedApprovalObjects;
    object.signaturedata = approvalData.SignatureData;
    object.filesdata = uploadedFileList;

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBApproval/IBBApprovalSaveCustomBulkApprovals",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setApprovalDataModalConfirmation(false);
          setSelectedApprovalObjects([]);
          setSelectedApprovalUsers([]);
          IBBScorecardGetDataForBulkInput(0);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  const handleSave = (signatureDataUrl: string) => {
    approvalData.SignatureData = signatureDataUrl;
  };

  return (
    <>
      {showAnimation && <LoadingAnimation />}

      <DownloadPopup
        ShowPopup={showPopUp}
        FileLink={popUpFileURL}
        Message={popUpMessage}
        DownloadPopupCallBack={DownloadPopupCallBack}
      />

      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>targets &amp; actuals</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div className="flex-items">
              <div className="flex-items">
                <select
                  className="select-md"
                  value={bulkInputFilter.ProgramID}
                  onChange={(e) => {
                    setBulkInputFilter((prevState: any) => ({
                      ...prevState,
                      ProgramID: Number(e.target.value),
                      QuarterID: 0,
                      IBBScorecardID: 0,
                      SectionID: 0,
                    }));
                    globalState.setTopFilterData((prevState: any) => ({
                      ...prevState,
                      IBBProgramID: Number(e.target.value),
                      QuarterID: 0,
                    }));
                    IBBProgramGetProgramListForScorecard(
                      Number(e.target.value),
                      0,
                      0,
                      0
                    );
                  }}
                >
                  {programList &&
                    programList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"program" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>

                <select
                  style={{ marginLeft: 5 }}
                  className="select-md"
                  value={bulkInputFilter.QuarterID}
                  onChange={(e) => {
                    setBulkInputFilter((prevState: any) => ({
                      ...prevState,
                      QuarterID: Number(e.target.value),
                    }));
                    globalState.setTopFilterData((prevState: any) => ({
                      ...prevState,
                      QuarterID: Number(e.target.value),
                    }));
                  }}
                >
                  {quarterList &&
                    quarterList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"quarter" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>

                <select
                  className="select-md"
                  value={bulkInputFilter.SectionID}
                  onChange={(e) => {
                    let SectionID = Number(e.target.value);

                    let IBBDepartmentID = 0;
                    let filtered = sectionsList.filter(
                      (item: any) => item.SectionID == SectionID
                    );

                    if (filtered.length > 0) {
                      IBBDepartmentID = filtered[0].IBBDepartmentID;
                    }

                    setBulkInputFilter((prevState: any) => ({
                      ...prevState,
                      SectionID: SectionID,
                      IBBDepartmentID: IBBDepartmentID,
                    }));
                  }}
                >
                  {sectionsList &&
                    sectionsList.map((Item: any, index: any) => (
                      <option
                        value={Item.SectionID}
                        key={"section" + Item.SectionID}
                      >
                        {Item.Title}
                      </option>
                    ))}
                </select>
              </div>

              <select
                className="select-md"
                value={bulkInputFilter.TypeID}
                onChange={(e) =>
                  setBulkInputFilter((prevState: any) => ({
                    ...prevState,
                    TypeID: Number(e.target.value),
                  }))
                }
              >
                {typeList &&
                  typeList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"type" + index}>
                      {Item.Name}
                    </option>
                  ))}
              </select>
            </div>
            {getAccessSettings(1, bulkInputFilter.IBBDepartmentID) > 1 && (
              <div className="flex-items">
                <a
                  className="btn-link"
                  onClick={() => IBBScorecardGetDataForBulkInput(1)}
                >
                  Download Input File
                </a>
                {(deadlineAccessData.CanInputData == 1 ||
                  globalState.ManageAdmin) && (
                  <div className="centre-drop-cl">
                    <div className="drad-drop">
                      <DragDrop
                        ParentFeatures={dragDropFeatures}
                        DragDropCallback={handleDragDropCallback}
                        TriggerChild={triggerChild}
                      />
                    </div>
                    <div className="help-btns">
                      <a onClick={() => showPopUpForSaveFiles()}>Import Data</a>
                    </div>
                    <a
                      className="btn-primary"
                      title="Export"
                      onClick={() =>
                        DownloadClientsDataInExcel(
                          "tbltargets&actuals",
                          "TARGETS & ACTUALS"
                        )
                      }
                    >
                      <img src="images/export.svg" width="18" height="18" />
                    </a>
                  </div>
                )}
              </div>
            )}

            {selectedApprovalObjects.length > 0 &&
              (deadlineAccessData.CanApproveData == 1 ||
                globalState.ManageAdmin) && (
                <div
                  className="flex-container"
                  style={{ marginBottom: 0, marginTop: 10 }}
                >
                  <span></span>
                  <div className="flex-items">
                    <a
                      className="btn-app-rej"
                      onClick={() => {
                        setApprovalData((prevState: any) => ({
                          ...prevState,
                          Status: 1,
                        }));
                        setApprovalDataModalConfirmation(true);
                      }}
                    >
                      Approve Selected
                    </a>
                    <a
                      className="btn-app-rej"
                      onClick={() => {
                        setApprovalData((prevState: any) => ({
                          ...prevState,
                          Status: 2,
                        }));
                        setApprovalDataModalConfirmation(true);
                      }}
                    >
                      Reject Selected
                    </a>
                  </div>
                </div>
              )}
          </div>
          <div className="section-table tab-bulk">
            <table
              className="part-head trend-table fixed-table"
              id="tbltargets&actuals"
            >
              <thead>
                <tr>
                  {inputDataColumns &&
                    inputDataColumns.map((item: any, index: any) => (
                      <React.Fragment key={"column" + index}>
                        {item.ColumnName != "SCID" &&
                          item.ColumnName != "RID" && (
                            <th>{item.ColumnName}</th>
                          )}
                      </React.Fragment>
                    ))}
                  <th className="md-col">
                    <div className="width-100 text-center btn-sm-grid">
                      {bulkInputFilter.TypeID == 2 &&
                        getAccessSettings(1, bulkInputFilter.IBBDepartmentID) >
                          1 && (
                          <a
                            className="btn-primary btngrid"
                            title="Manage Supporting Document"
                            onClick={() => {
                              let approvalDataLocal = {} as any;
                              approvalDataLocal.SCID = 0;
                              setApprovalData(approvalDataLocal);
                              getAttachmentDataForObjectTypeAndObjectID(
                                AppContext.FileUploadObjectTypeScorecardActualsEvidenceFile,
                                bulkInputFilter.SectionID,
                                0
                              );
                            }}
                          >
                            <img
                              src="images/attach.svg"
                              width={15}
                              height={15}
                            />
                          </a>
                        )}
                      <a
                        className="btn-primary btngrid"
                        title="View All Approvals Data"
                        onClick={() => {
                          let approvalDataLocal = {} as any;
                          approvalDataLocal.SCID = 0;
                          setApprovalData(approvalDataLocal);
                          setApprovalDataModal(true);
                        }}
                      >
                        <img src="images/eye.svg" width={15} height={15} />
                      </a>

                      {canTakeActionItems > 0 && (
                        <input
                          checked={
                            selectedApprovalObjects.length == canTakeActionItems
                              ? true
                              : false
                          }
                          type="checkbox"
                          onChange={(e) => {
                            if (
                              selectedApprovalObjects.length <
                              canTakeActionItems
                            ) {
                              let approvalDataLocal = {} as any;

                              let selectedApprovalObjectsLocal = [
                                ...selectedApprovalObjects,
                              ] as any;
                              let selectedApprovalUsersLocal = [
                                ...selectedApprovalUsers,
                              ] as any;

                              for (let i = 0; i < inputData.length; i++) {
                                let item = inputData[i];
                                if (item.ApprovalData != null) {
                                  approvalDataLocal.ObjectID =
                                    item.ApprovalData?.ObjectID;
                                  approvalDataLocal.IBBRequiredApprovalUserID =
                                    item.ApprovalData?.IBBRequiredApprovalUserID;
                                  approvalDataLocal.IBBDelegateID =
                                    item.ApprovalData?.IBBDelegateID;

                                  let index =
                                    selectedApprovalObjectsLocal.indexOf(
                                      approvalDataLocal.ObjectID
                                    );
                                  if (index <= -1) {
                                    selectedApprovalObjectsLocal.push(
                                      item.ApprovalData.ObjectID
                                    );
                                    selectedApprovalUsersLocal.push(
                                      item.ApprovalData
                                        .IBBRequiredApprovalUserID
                                    );
                                  }
                                }
                              }

                              if (approvalDataLocal.ObjectID > 0) {
                                setSelectedApprovalObjects(
                                  selectedApprovalObjectsLocal
                                );
                                setSelectedApprovalUsers(
                                  selectedApprovalUsersLocal
                                );
                                setApprovalData(approvalDataLocal);
                              }
                            } else {
                              setSelectedApprovalObjects([]);
                              setSelectedApprovalUsers([]);
                            }
                          }}
                        ></input>
                      )}
                      {canTakeActionItems == 0 && (
                        <span className="empty-span"></span>
                      )}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {inputData &&
                  inputData.map((item: any, index: any) => (
                    <React.Fragment key={"row" + index}>
                      <tr>
                        {inputDataColumns &&
                          inputDataColumns.map(
                            (column: any, columnIndex: any) => (
                              <React.Fragment key={"rowcolumn" + columnIndex}>
                                {column.ColumnName != "SCID" &&
                                  column.ColumnName != "RID" && (
                                    <td>
                                      {column.DataFormat.TargetValueFormat &&
                                        column.DataFormat.TargetValueFormat !=
                                          3 &&
                                        item[column.ColumnName] && (
                                          <span>
                                            <InputMaskReadOnly
                                              Disabled={true}
                                              Prefix={
                                                column.DataFormat
                                                  .TargetValueFormat == 4 ||
                                                column.DataFormat
                                                  .ActualValueFormat == 4
                                                  ? column.DataFormat
                                                      .CurrencyIcon
                                                  : ""
                                              }
                                              Suffix={
                                                column.DataFormat
                                                  .TargetValueFormat == 2 ||
                                                column.DataFormat
                                                  .ActualValueFormat == 2
                                                  ? "%"
                                                  : ""
                                              }
                                              ToFixed={0}
                                              ClassName=""
                                              ColumnName="1"
                                              Value={Number(
                                                item[column.ColumnName]
                                              )}
                                              PID={item.SCID}
                                            />
                                          </span>
                                        )}
                                      {(column.DataFormat.TargetValueFormat ==
                                        undefined ||
                                        (column.DataFormat.TargetValueFormat &&
                                          column.DataFormat.TargetValueFormat ==
                                            3)) && (
                                        <>{item[column.ColumnName]}</>
                                      )}
                                    </td>
                                  )}
                              </React.Fragment>
                            )
                          )}
                        <td className="md-col">
                          <div className="width-100 text-center btn-sm-grid">
                            {bulkInputFilter.TypeID == 2 &&
                              getAccessSettings(
                                1,
                                bulkInputFilter.IBBDepartmentID
                              ) > 1 && (
                                <a
                                  className="btn-primary btngrid"
                                  title="Manage Supporting Document"
                                  onClick={() => {
                                    let approvalDataLocal = {} as any;
                                    approvalDataLocal.SCID = item.SCID;
                                    setApprovalData(approvalDataLocal);
                                    getAttachmentDataForObjectTypeAndObjectID(
                                      AppContext.FileUploadObjectTypeScorecardActualsEvidenceFile,
                                      bulkInputFilter.SectionID,
                                      item.SCID
                                    );
                                  }}
                                >
                                  <img
                                    src="images/attach.svg"
                                    width={15}
                                    height={15}
                                  />
                                </a>
                              )}
                            <a
                              className="btn-primary btngrid btn-no-back"
                              title="View Approval Data"
                              onClick={() => {
                                let approvalDataLocal = {} as any;
                                approvalDataLocal.SCID = item.SCID;
                                setApprovalData(approvalDataLocal);
                                setApprovalDataModal(true);
                              }}
                            >
                              <img
                                title={
                                  item.ApprovalStatus == 1
                                    ? "Approved"
                                    : item.ApprovalStatus == 2
                                    ? "Rejected"
                                    : "In Progress"
                                }
                                src={
                                  item.ApprovalStatus == 1
                                    ? "images/done.svg"
                                    : item.ApprovalStatus == 2
                                    ? "images/refused.svg"
                                    : "images/in-progress.svg"
                                }
                                width={25}
                                height={25}
                              />
                            </a>
                            {item.ApprovalData?.CanTakeAction == 1 && (
                              <input
                                checked={
                                  selectedApprovalObjects.indexOf(
                                    item.ApprovalData.ObjectID
                                  ) > -1
                                    ? true
                                    : false
                                }
                                type="checkbox"
                                onChange={(e) => {
                                  let approvalDataLocal = {} as any;
                                  approvalDataLocal.ObjectID =
                                    item.ApprovalData?.ObjectID;
                                  approvalDataLocal.IBBRequiredApprovalUserID =
                                    item.ApprovalData?.IBBRequiredApprovalUserID;
                                  approvalDataLocal.IBBDelegateID =
                                    item.ApprovalData?.IBBDelegateID;

                                  let selectedApprovalObjectsLocal = [
                                    ...selectedApprovalObjects,
                                  ] as any;
                                  let selectedApprovalUsersLocal = [
                                    ...selectedApprovalUsers,
                                  ] as any;

                                  let index =
                                    selectedApprovalObjectsLocal.indexOf(
                                      approvalDataLocal.ObjectID
                                    );
                                  if (index > -1) {
                                    selectedApprovalObjectsLocal.splice(
                                      index,
                                      1
                                    );
                                    selectedApprovalUsersLocal.splice(index, 1);
                                  } else {
                                    selectedApprovalObjectsLocal.push(
                                      item.ApprovalData?.ObjectID
                                    );
                                    selectedApprovalUsersLocal.push(
                                      item.ApprovalData
                                        ?.IBBRequiredApprovalUserID
                                    );
                                  }

                                  setSelectedApprovalObjects(
                                    selectedApprovalObjectsLocal
                                  );
                                  setSelectedApprovalUsers(
                                    selectedApprovalUsersLocal
                                  );
                                  setApprovalData(approvalDataLocal);
                                }}
                              ></input>
                            )}
                            {!item.ApprovalData?.CanTakeAction && (
                              <span className="empty-span"></span>
                            )}
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {approvalDataModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head" style={{ marginBottom: 0 }}>
                <h3>Approvals</h3>
                <a
                  className="close-help"
                  onClick={() => setApprovalDataModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div
                className="plr-20 bulk-padding"
                style={{ maxHeight: 550, overflow: "auto", paddingBottom: 20 }}
              >
                <ApprovalsScreen
                  approvalObjectType={bulkInputFilter.TypeID == 1 ? 10 : 14}
                  approvalObjectID={approvalData.SCID}
                  IBBProgramID={bulkInputFilter.ProgramID}
                  QuarterID={bulkInputFilter.QuarterID}
                  IBBProgramSectionID={bulkInputFilter.SectionID}
                  ApprovalTextType={1}
                  uploadObjectType={
                    bulkInputFilter.TypeID == 1
                      ? AppContext.FileUploadObjectTypeTargetApprovalFile
                      : AppContext.FileUploadObjectTypeActualApprovalFile
                  }
                  requiredApprovalUser={requiredApprovalUser}
                  triggerApprovalParent={triggerApprovalParent}
                ></ApprovalsScreen>
              </div>
            </div>
          </div>
        </div>
      )}

      {approvalDataModalConfirmation && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Confirmation</h3>
                <a
                  className="close-help"
                  onClick={() => setApprovalDataModalConfirmation(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">
                {approvalData.IsSignatureRequired && (
                  <>
                    {" "}
                    <span className="buis-head">Signature</span>
                    <SignaturePadControl
                      onSave={handleSave}
                    ></SignaturePadControl>
                  </>
                )}
              </div>
              <div className="help-btns">
                <div>
                  Are you sure you want to{" "}
                  <b>{approvalData.Status == 1 ? "Approve" : "Reject"}</b> it?
                  You will not be able to revert it.
                </div>

                <a
                  onClick={() => {
                    IBBApprovalSaveCustomBulkApprovals([]);
                  }}
                >
                  Yes
                </a>
                <a onClick={() => setApprovalDataModalConfirmation(false)}>
                  No
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDragDropModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head" style={{ marginBottom: 0 }}>
                <h3>Supporting Document</h3>
                <a
                  className="close-help"
                  onClick={() => setShowDragDropModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="plr-20 pad-t20">
                <div className="flex-items justify-center">
                  <div className="centre-drop-cl">
                    <div className="drad-drop">
                      <DragDrop
                        ParentFeatures={dragDropFeaturesModal}
                        DragDropCallback={handleDragDropCallbackModal}
                        TriggerChild={triggerChildModal}
                      />
                    </div>
                    <div className="help-btns">
                      {(deadlineAccessData.CanInputData == 1 ||
                        globalState.ManageAdmin) && (
                        <a onClick={() => SaveFilesModal()}>Save</a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BulkInput;
